import { apiService } from './index';
import { TOKEN } from '../contexts/authContext';

export const asyncPostCreateCaseOTRSPQROnTime = (caseId: string) => {
    return apiService.post(
        `/api/commercial-crm/createCaseOTRSPQROnTime/${caseId}`,
        {},
        undefined,
        {
            accept: '*/*',
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};
